import { render, staticRenderFns } from "./MastheadItem.vue?vue&type=template&id=2483e99a&scoped=true&"
import script from "./MastheadItem.vue?vue&type=script&lang=js&"
export * from "./MastheadItem.vue?vue&type=script&lang=js&"
import style0 from "./MastheadItem.vue?vue&type=style&index=0&id=2483e99a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2483e99a",
  null
  
)

export default component.exports